const api = {
  GET_LIST_BANK_AS_SERVER: '/index.php?r=api/v1/system_log/service-log/bank-as-server',
};

export default api;
